
<template>
	<vs-popup
		:active.sync="$props.popupActive"
		:title="'GT Metrix: ' + $props.prospect_url"
	>
		<div class="chart-container">
			{{ gtMetrixData }}
		</div>
	</vs-popup>
</template>
  
  <script>
export default {
	name: "ProspectGtMetrixPopup",
	components: {},
	props: {
		popupActive: {
			type: Boolean,
			required: true,
		},
		gtMetrixData: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {};
	},
	created() {},
};
</script>
  
  <style>
/* You can add some styles here if needed */
</style>
  